import React from 'react';

// Reason: every class is prefixed. The design's own names (.label, .figure, .cite, .stat-card) are
// exactly the kind that collide with the global utility stylesheets.
const STATS = [
    { tone: 'blue', label: "of VCs don't raise a second fund", figure: '>50%', cite: 'Pitchbook' },
    { tone: 'violet', label: 'of applications get no reply', figure: '70%', cite: 'Diligentsia' },
    { tone: 'coral', label: 'of startups get VC funding', figure: '0.05%', cite: 'CB Insights' },
    { tone: 'blue', label: "of VC-backed startups don't return money", figure: '75%', cite: 'Failory' },
    { tone: 'violet', label: 'of startups fail', figure: '90%', cite: 'Startup Genome' },
    { tone: 'coral', label: 'of UK exits suffer a price chip', figure: '60%', cite: 'Bizma' },
];

const HomeOddsSection = () => (
    <section className="lp-hstats">
        <div className="lp-hstats-inner">
            <div className="lp-hstats-head" data-lp-reveal>
                <h2>We all think we can outperform the market.</h2>
            </div>

            <div className="lp-hstats-grid">
                {STATS.map((s, i) => (
                    <div className={`lp-hstat-card is-${s.tone}`} key={s.cite + i} data-lp-reveal data-lp-delay={i * 70}>
                        <div className="lp-hstat-label">{s.label}</div>
                        <div className="lp-hstat-figure">{s.figure}</div>
                        <div className="lp-hstat-cite">{s.cite}</div>
                    </div>
                ))}
            </div>

            <p className="lp-hstats-foot" data-lp-reveal>Whoever you are, we give you the tools to beat these odds.</p>
        </div>
    </section>
);

export default HomeOddsSection;
